import React, { useMemo, useState } from "react";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";

import ParkkiTheme from "themes/ParkkiTheme";

import LiveButton from "components/LiveButton";
import SelectedLayersSection from "components/SelectedLayersSection";
import SelectedLayersSectionButton from "components/SelectedLayersSectionButton";

const LeftFilters = styled(Paper)`
  position: absolute;
  top: 74px;
  left: 10px;
  z-index: 500;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: ${ParkkiTheme.colors.lightGrey};
  max-width: 30%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledLiveButton = styled(LiveButton)`
  margin-right: 25px;
`;

function Filters({
  currentFloorLayers,
  loading,
  liveReloadActive,
  onSelectLayers,
  onReloadOnce,
  onAutoReloadChecked,
}) {
  const [toggleLayersSection, setToggleLayersSection] = useState(false);

  const areas = useMemo(() => {
    return currentFloorLayers?.areas.filter(
      (layer) => layer.apiType !== "UNEQUIPPED"
    );
  }, [currentFloorLayers?.areas]);

  return (
    <LeftFilters>
      <ButtonsContainer>
        <StyledLiveButton
          withLiveReload={liveReloadActive}
          onReload={onReloadOnce}
          onChecked={onAutoReloadChecked}
        />

        <SelectedLayersSectionButton
          toggled={toggleLayersSection}
          onClick={() => setToggleLayersSection(!toggleLayersSection)}
        />
      </ButtonsContainer>

      {toggleLayersSection ? (
        <SelectedLayersSection
          loading={loading}
          areas={areas}
          points={currentFloorLayers?.points}
          paths={currentFloorLayers?.paths}
          onSelectLayers={onSelectLayers}
        />
      ) : null}
    </LeftFilters>
  );
}

export default Filters;
